<template>
  <div class="content">
    <img :src="imgMap[order.status]" />
    <div>
      <div class="title">{{ order.statusName }}</div>
      <div v-if="order.status === 4" class="desc">
        退款将于7个工作日内原路返回您的账户
      </div>
      <div v-else-if="order.status === 0" class="desc">
        <x-countdown
          :date="order.countDownTime"
          @end="handleFinish(order.countDownTime)"
        />
        后关闭订单
      </div>
      <div v-else-if="order.status === 2" class="desc">
        <x-countdown
          :date="order.countDownTime"
          @end="handleFinish(order.countDownTime)"
        />
        后结束
      </div>
    </div>
  </div>
</template>

<script>
  import { padStart } from 'vtils'
  export default {
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    computed: {
      imgMap() {
        return {
          0: require('./images/待支付.png'),
          1: require('./images/已关闭.png'),
          2: require('./images/待支付.png'),
          3: require('./images/已完成.png'),
          4: require('./images/已关闭.png'),
        }
      },
    },

    methods: {
      padLeft(text) {
        return padStart(text, 2, '0')
      },
      handleFinish(time) {
        // 避免死循环：到了发货时间，商家都没发货，time 为 0
        if (time !== 0) {
          this.$emit('finish')
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .content {
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 16px;
    img {
      width: 36px;
      height: 36px;
      flex-shrink: 0;
      margin-right: 16px;
    }
  }
  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #222222;
  }
  .desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    padding-top: 4px;
  }
  .van-count-down {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
  }
</style>
